import type { Platform, PlatformData, PlatformDataMap } from 'src/app/pages/starterDashboardV2/shared/hooks';
import type { ReadyToSharePostWithPlatform } from 'src/app/shared/api/readyToShare';

import type { FullPostType } from '../factories/types';

type PlatformMapping = {
	platformName: Platform;
	postPlatformName: ReadyToSharePostWithPlatform['platform'];
	postTypeName: ReadyToSharePostWithPlatform['postTypeName'];
};

const FULL_POST_TYPE_RTS_PLATFORM_MAP: Record<FullPostType, PlatformMapping> = {
	facebook_post: {
		platformName: 'FACEBOOK',
		postPlatformName: 'facebook',
		postTypeName: 'post',
	},
	facebook_story: {
		platformName: 'FACEBOOK',
		postPlatformName: 'facebook',
		postTypeName: 'story',
	},
	facebook_group_post: {
		platformName: 'FACEBOOKGROUPS',
		postPlatformName: 'facebookgroups',
		postTypeName: 'post',
	},
	instagram_post: {
		platformName: 'INSTAGRAM',
		postPlatformName: 'instagram',
		postTypeName: 'post',
	},
	instagram_story: {
		platformName: 'INSTAGRAM',
		postPlatformName: 'instagram',
		postTypeName: 'story',
	},
	reddit_post: {
		platformName: 'REDDIT',
		postPlatformName: 'reddit',
		postTypeName: 'post',
	},
	reddit_group_post: {
		platformName: 'REDDIT',
		postPlatformName: 'reddit',
		postTypeName: 'post',
	},
};

export function platformDataForFullPostType(
	fullPostType: FullPostType,
	readyToSharePlatformData: PlatformDataMap,
): PlatformData | undefined {
	const { platformName } = FULL_POST_TYPE_RTS_PLATFORM_MAP[fullPostType];
	return readyToSharePlatformData[platformName];
}

export function rtsForFullPostType(
	fullPostType: FullPostType,
	readyToSharePlatformData: PlatformDataMap,
): ReadyToSharePostWithPlatform | undefined {
	const { platformName, postPlatformName, postTypeName } = FULL_POST_TYPE_RTS_PLATFORM_MAP[fullPostType];

	const platformData = readyToSharePlatformData[platformName];
	if (!platformData?.items || platformData.items.length === 0) {
		return undefined;
	}

	return platformData.items.find((rts) => rts.platform === postPlatformName && rts.postTypeName === postTypeName);
}
